/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Pipe, PipeTransform} from '@angular/core';

import {formatLocalePercent} from '../locale/locale-number-format';
import {AppLocaleService} from '../locale/app-locale.service';

@Pipe({
  standalone: true,
  name: 'localePercent',
  pure: false
})
export class LocalePercentPipe implements PipeTransform {
  constructor(private readonly appLocale: AppLocaleService) {
  }

  transform(value: number | string | null | undefined, digitsInfo?: string): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return formatLocalePercent(value, digitsInfo, this.appLocale.getLocaleId());
  }
}
